import { render, staticRenderFns } from "./ScoringSurveysPage.vue?vue&type=template&id=512fb8af"
import script from "./ScoringSurveysPage.vue?vue&type=script&lang=ts"
export * from "./ScoringSurveysPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports